import RoleHome from '../RoleHome';

export default function WardStaffPage() {
  return (
    <RoleHome
      title="Ward staff"
      description="Day‑to‑day ward, bed, admission, transport, and diet tasks."
    />
  );
}
